// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__OaJ9-","bigColWidth":"Table_bigColWidth__1jlPb","biggerColWidth":"Table_biggerColWidth__1Fzmz","row":"Table_row__16SyA","col":"Table_col__1Xjqw"};